import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* createLookbookOrderFulfillment({ payload: { id, orderId, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.orders.fulfillments.create, pathParams: { id, orderId }, data: values });

    onSuccess && onSuccess();
    yield put(actions.createLookbookOrderFulfillmentDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createLookbookOrderFulfillmentFailed,
      onError,
      handledErrors,
      endpoint: api.lookbooks.orders.fulfillments.create.url
    });
  }
}

export const createLookbookOrderFulfillmentSaga = takeEvery(types.CREATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST, createLookbookOrderFulfillment);
